export const ForwardSlash = ({
  width = 24,
  height = 24,
  className,
  title = "Forward Slash",
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}>
      <title>{title}</title>
      <path
        d="M14.293 6.80478L9.22155 17.6805"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
